<template>
     <div class="form-box">
        <el-form 
            :model="form" 
            :rules="rules" 
            ref="ruleForm" 
            label-width="150px" 
        >
            <el-form-item label="自定义最近天数限制：" prop="customize_the_latest_days">
                  <el-input style="width: 220px" v-model.trim.number="form.customize_the_latest_days" placeholder="请输入" @blur="validateDate"/>
                  <div class="el-form-item__error">用户设置的自定义最近天数的输入值不可超过此处眼制</div>
            </el-form-item>
            <el-form-item label="自定义开始日期限制：" prop="customize_the_start_date">
               <el-date-picker
                   @change="validateDays"
                    v-model="form.customize_the_start_date"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="请选择">
                </el-date-picker>
                <div class="el-form-item__error">用户不可选择此处限制之前的日期(包含当天)</div>
            </el-form-item>
        </el-form>
        <FileListInput v-model="form.file_list"/>
        <div class="btns">
            <el-button :disabled="loading" @click="$emit('close')">取消</el-button>
            <el-button :loading="loading" type="primary" @click="handlesSubmit('ruleForm')">添加</el-button>
        </div>
    </div>
</template>

<script>
import FileListInput from '../components/fileListInput.vue'
import { validNum } from '@/utils/validate'
export default {
    name: 'AddFileWhiteDialog',
    props: [ 'cbs' ],
    components: {
        FileListInput
    },
    data() {
        let _this = this;
        const validateLatestDays = (rule, value, callback)=> {
            const num = value+'';
            if(_this.form.customize_the_start_date){
                if(!value){
                    callback()
                }else if (validNum(num)) {
                    callback()
                }else {
                    callback(new Error('请输入数字'))
                }
            }else{
                if(!value){
                    callback(new Error('请输入最近天数限制'))
                }else if (validNum(num)) {
                    callback()
                }else {
                    callback(new Error('请输入数字'))
                }
            }
        };
        const validateStartDate = (rule, value, callback)=> {
            if(_this.form.customize_the_latest_days){
                callback()
            }else if(!value){
                callback(new Error('请输入开始日期限制'));
            }else{
                callback()
            }
        };
        return {
            form: {
                customize_the_latest_days: '',
                file_list: [],
                customize_the_start_date: ''
            },
            rules: {
                customize_the_latest_days: [
                    { validator: validateLatestDays, trigger: 'blur' },
                ],
                customize_the_start_date: [
                    { validator: validateStartDate, trigger: 'blur' },
                ]
            },
            loading: false
        }
    },
    methods: {
        handlesSubmit(formName) {
            this.$refs[formName].validate(async (valid) => {
                if (valid) {
                    const file_list = this.form.file_list.filter(v=> {
                        return !!v.trim()
                    });
                    if (!file_list.length) {
                        this.$message.error('文件列表不能为空')
                        return
                    };
                    this.loading = true;
                    this.cbs.onSubmit({ 
                        ...this.form,
                        file_list
                    }, (list)=> {
                        this.loading = false
                        if (list) {
                            this.form.file_list = list;
                            this.handlesSubmit('ruleForm')
                        }
                    });
                    
                } else {
                    return false;
                }
            });
        },
        validateDays(){
            this.$refs.ruleForm.validateField('customize_the_latest_days');
        },
        validateDate(){
            this.$refs.ruleForm.validateField('customize_the_start_date');
        },
    }
}
</script>

<style lang="scss" scoped>
.form-box ::v-deep {
    .el-form-item__error {
        width: 100%;
       background-color: #fff;
    }
}
.el-form-item__error {
    color: #bbb;
}
.btns {
    text-align: center;
    margin-top: 12px;
}
</style>
